import { map, mergeMap, catchError } from "rxjs/operators";
import { ofType } from "redux-observable";
import { LVGoalsPDFService } from "../../../common/services";
import * as actionTypes from "./actionTypes";
import * as lvgActions from "./actions";

export function saveLVGoalsPDF(action$) {
  return action$.pipe(
    ofType(actionTypes.SAVE_LG_PDF),
    mergeMap(({ payload }) => {
      return LVGoalsPDFService.saveLVGoalsPDF(payload).pipe(
        map((res) =>
        lvgActions.saveLVGoalsPDFSuccess(res.responceObject.records)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}